import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";

function Navbar() {
  const { siteData } = useContext(AuthContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  return (
    <nav
      id="navbar"
      className="fixed w-full z-50 bg-neutral-900 text-white font-poppins"
    >
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <a href="#hero" className="flex items-center">
              <img className="h-10 w-auto" src={siteData?.logo} alt="Logo" />
              <span className="ml-2 text-lg font-semibold">
                {siteData?.name}
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {["Home", "About Us", "Services", "Reviews", "Contact"].map(
              (item, index) => (
                <a
                  key={index}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="text-white hover:text-blue-400 transition-colors"
                >
                  {item}
                </a>
              )
            )}
            <a
              href="#appointment"
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              Book Appointment
            </a>
          </div>

          {/* Mobile Hamburger Button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-neutral-900">
          <div className="px-4 pt-2 pb-3 space-y-1">
            {["Home", "About Us", "Services", "Reviews", "Contact"].map(
              (item, index) => (
                <a
                  key={index}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="block text-white hover:text-blue-400 transition-colors py-2"
                >
                  {item}
                </a>
              )
            )}
            <a
              href="#appointment"
              className="block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors mt-4"
            >
              Book Appointment
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
